import React from 'react'
import { Stack } from 'react-bootstrap'
import { Field } from '@ztechapps/webui.form'
import { useUser } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'
import { useInjectComponent, WebuiIocKey } from '@ztechapps/webui.contract'

export const QuickAddTaskForm = () => {
  const ProjectSelect = useInjectComponent(WebuiIocKey.project.projectSelect)
  const { user } = useUser()

  return (
    <Stack gap={2}>
      <Field label="Project" name="project" component={ProjectSelect} onChange filter={{}} required />
      <Field label="Task Name" name="name" required />
      <ShowIf condition={!!user?.profile?.name}>
        <div>
          <small className="text-secondary">Assignee: {user?.profile?.name}</small>
        </div>
      </ShowIf>
    </Stack>
  )
}
